import React from "react";
import PictureAsPdf from "@material-ui/icons/PictureAsPdf";
import InsertDriveFileOutlined from "@material-ui/icons/InsertDriveFileOutlined";
import Search from "@material-ui/icons/Search";
import { RowButton } from "../../../common/RowButtons";
import { SecuredMenuLinkButton } from "lego-gui-lib";
import { inject } from "mobx-react";

export const customRowButtons = (indexProps: any) => (
  row: any,
  key: string,
  close: () => void
) => {
  const arr = [];

  const ViewButton = inject("i18n")(({ i18n: i18n, ...props }) => {
    const title = i18n.t("common:view", "View");
    return (
      <SecuredMenuLinkButton title={title} {...props}>
        {props.children}
      </SecuredMenuLinkButton>
    );
  });

  const getAsCsv = (e: any) => {
    indexProps.props.dataSource.getAsCsv(row.id);
    close();
  };

  const getAsPdf = (e: any) => {
    indexProps.props.dataSource.getAsPdf(row.id);
    close();
  };

  arr.push(
    <ViewButton link={indexProps.props.columns.link(row)} key={key + "edit"}>
      <Search color={"inherit"} />
    </ViewButton>
  );

  arr.push(
    <RowButton
      callbackFunction={getAsPdf}
      title={["hns:report:pdf", "Download as .pdf"]}
      key={key + "pdf"}
    >
      <PictureAsPdf />
    </RowButton>
  );

  arr.push(
    <RowButton
      callbackFunction={getAsCsv}
      title={["hns:report:csv", "Download as .csv"]}
      key={key + "csv"}
    >
      <InsertDriveFileOutlined />
    </RowButton>
  );

  return arr;
};
